import { Button } from "@/ingot";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { DEFAULT_LANG, isSupportedLang } from "@/i18n";
import {
  endCustomerPreview,
  isCustomerPreview,
} from "@/lib/customerPreview";

/**
 * Trvalý pruh nad obchodem, který admin prohlíží jako zákazník (KAN-747).
 *
 * Bez něj je náhled k nerozeznání od pravdy: tenant vidí svůj obchod
 * odhlášený, nechápe, kam se poděl admin, a cesta zpátky žádná není.
 *
 * Odchod je **tvrdá navigace**, ne ``navigate()`` z routeru: náhled
 * vypíná ``credentials`` pro celý tab a react-query drží cache
 * anonymních odpovědí. Nové načtení dokumentu obojí smete —
 * překreslení uvnitř SPA by admina pustilo do adminu s cache, kterou
 * naplnil někdo jiný.
 */
export function CustomerPreviewBanner(): JSX.Element | null {
  const { t } = useTranslation("admin");
  const params = useParams<{ lang?: string }>();
  const lang =
    params.lang && isSupportedLang(params.lang) ? params.lang : DEFAULT_LANG;

  if (!isCustomerPreview()) return null;

  return (
    <div
      className="sticky top-0 z-50 border-b border-border bg-ink text-bg"
      data-testid="customer-preview-banner"
      role="status"
    >
      <div className="mx-auto flex w-full max-w-[1440px] flex-wrap items-center gap-3 px-4 py-2 sm:px-6 lg:px-8">
        <span className="mono inline-flex items-center rounded bg-bg/20 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider">
          {t("customerPreview.tag")}
        </span>
        <p className="min-w-0 flex-1 text-sm">{t("customerPreview.lead")}</p>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            endCustomerPreview();
            window.location.assign(`/${lang}/admin`);
          }}
          data-testid="customer-preview-exit"
        >
          {t("customerPreview.exit")}
        </Button>
      </div>
    </div>
  );
}
